import React from 'react'
import PropTypes from 'prop-types'
import DropZone from '../DropZone'

const UploadVideo = ({ isUploaded }) => {
  return (
    <div className="">
      <h2 className="text-[#F67443] text-[30px] text-center mb-4 font-semibold">
        Upload Video Introduction
      </h2>
      <DropZone type="video" isUploaded={isUploaded} />
    </div>
  )
}
UploadVideo.propTypes = {
  isUploaded: PropTypes.bool,
}
export default React.memo(UploadVideo)
